import { useState } from 'react';
import { useSiteSettings } from '../../lib/hooks';
import { DEFAULT_SETTINGS, type SiteSettingsDoc } from '../../lib/data-model';
import { Loading } from '../ui';
import { SwitchRow, useSaver } from './ListAdmin';

export function SettingsTab() {
  const { data, loading } = useSiteSettings();
  if (loading) return <Loading label="Loading settings…" />;
  return <SettingsForm key={data?.updatedAt ?? 'fresh'} initial={{ ...DEFAULT_SETTINGS, ...data }} />;
}

function SettingsForm({ initial }: { initial: SiteSettingsDoc }) {
  const [appName, setAppName] = useState(initial.appName);
  const [tagline, setTagline] = useState(initial.tagline);
  const [footerText, setFooterText] = useState(initial.footerText);
  const [gamified, setGamified] = useState(initial.gamified ?? true);

  const dirty =
    appName !== initial.appName ||
    tagline !== initial.tagline ||
    footerText !== initial.footerText ||
    gamified !== (initial.gamified ?? true);

  const { errors, saving, save } = useSaver(
    'siteSettings',
    'global',
    () => ({ appName, tagline, footerText, gamified }),
    () => undefined
  );

  return (
    <div className="panel" style={{ maxWidth: 660 }}>
      <div className="admin-wrap">
        <fieldset className="fieldset">
          <legend>Branding</legend>
          <div className="field">
            <label>App name</label>
            <input type="text" value={appName} onChange={e => setAppName(e.target.value)} />
            {errors.appName ? <div className="error">{errors.appName}</div> : null}
          </div>
          <div className="field">
            <label>Tagline</label>
            <input type="text" value={tagline} onChange={e => setTagline(e.target.value)} />
            {errors.tagline ? <div className="error">{errors.tagline}</div> : null}
          </div>
          <div className="field">
            <label>Footer text</label>
            <input type="text" value={footerText} onChange={e => setFooterText(e.target.value)} />
            {errors.footerText ? <div className="error">{errors.footerText}</div> : null}
          </div>
        </fieldset>

        <fieldset className="fieldset">
          <legend>Experience</legend>
          <SwitchRow
            label="Gamification (XP, streaks, progress)"
            on={gamified}
            onToggle={() => setGamified(v => !v)}
            hint="Turn off to hide XP pills, streak badges and progress rings across the site."
          />
        </fieldset>

        <div className="save-bar">
          <span className="note">{dirty ? 'You have unsaved changes.' : 'All changes saved.'}</span>
          <button className="btn btn-primary" onClick={() => void save()} disabled={saving || !dirty}>
            {saving ? 'Saving…' : 'Save settings'}
          </button>
        </div>
      </div>
    </div>
  );
}
